/* eslint-disable react/sort-comp */
/* eslint-disable react/prefer-stateless-function */
import React from "react";
import ReactResizeDetector from "react-resize-detector";
import ReactTooltip from "react-tooltip";
import MapboxMap from "./MapboxMap";
import Filters from "./Filters";
import Panel from "./Panel/Panel";
import LegendColor from "./LegendColor";
import { DataContext } from "../context/DataContext";

class Body extends React.Component {
  state = {
    showPanel: false,
    showLegend: true,
  };

  elBody = React.createRef();

  static contextType = DataContext;

  handleShowPanel = (bool) => {
    this.setState({ showPanel: bool });
  };

  handleShowLegend = (bool) => {
    this.setState({ showLegend: bool });
  };

  componentDidMount() {
    // SET INITIAL VALUES FOR PANEL AND MAP DIMS
    const { setPanelDims, panelDims, setMapDims, mapDims } = this.context;
    const bodyDims = this.elBody.current.getBoundingClientRect();
    setPanelDims({
      ...panelDims,
      width: bodyDims.width,
    });
    setMapDims({
      ...mapDims,
      width: mapDims.width,
    });
  }

  render() {
    const {
      setMapDims,
      selection,
      judgesData,
      countyData,
      geoJson,
      changeSelection,
      choroplethColorKey,
      colorScale,
      legendData,
      colorLegendDims,
      panelDims,
    } = this.context;
    const { showPanel, showLegend } = this.state;
    if (countyData && judgesData) {
      return (
        <div className="body__container" ref={this.elBody}>
          <Filters />
          {colorScale && (
            <ReactResizeDetector
              handleWidth
              handleHeight
              refreshMode="debounce"
              refreshRate={500}
              onResize={(width, height) => setMapDims({ width, height })}
            >
              {({ targetRef }) => (
                <div className="overlay__container" ref={targetRef}>
                  <MapboxMap
                    handleShowPanel={this.handleShowPanel}
                    handleShowLegend={this.handleShowLegend}
                    geoData={geoJson}
                    choroplethData={countyData}
                    choroplethJoinKey="id"
                    choroplethColorKey={choroplethColorKey}
                    colorLegendDims={colorLegendDims}
                    panelDims={panelDims}
                    geoJoinKey="NAME"
                    selection={selection}
                    changeSelection={changeSelection}
                    colorScale={colorScale}
                  />
                  <LegendColor
                    showLegend={showLegend}
                    colorScale={colorScale}
                    title={legendData.title}
                    valFormatter={legendData.valFormatter}
                  />
                  <Panel showPanel={showPanel} />
                </div>
              )}
            </ReactResizeDetector>
          )}
          <ReactTooltip
            html
            type="info"
            id="tooltip__info-icon"
            className="panel__info-tooltip"
          />
        </div>
      );
    }
    return null;
  }
}

export default Body;
